import { Component, OnInit } from '@angular/core';
import { UserVendorService } from '../../services/user-vendor.service';

@Component({
  standalone: false,
  selector: 'app-current-vendor-description',
  templateUrl: './current-vendor-description.component.html',
  styleUrl: './current-vendor-description.component.scss'
})
export class CurrentVendorDescriptionComponent implements OnInit {

  currentVendorName: string
  currentPlaceName: string

  constructor(private readonly _userVendorService: UserVendorService) {

  }

  ngOnInit(): void {
    this.getCurrentVendorName();
  }

  private async getCurrentVendorName(): Promise<void> {
    const currentUserVendor = await this._userVendorService.getCurrentUserVendor();

    if (!currentUserVendor) {
      return;
    }

    this.currentVendorName = currentUserVendor.name;
    this.currentPlaceName = currentUserVendor.placeName;
  }
}
